import { render, staticRenderFns } from "./WasteBinDetails.vue?vue&type=template&id=79d16843&"
import script from "./WasteBinDetails.vue?vue&type=script&lang=js&"
export * from "./WasteBinDetails.vue?vue&type=script&lang=js&"
import style0 from "./WasteBinDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports